import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { API } from "common/config-api"; // jsconfig.json
import api from 'api';
import JsBarcode from 'jsbarcode'
import { CustomerButton } from "common/CustomerButton";
import { publishMessage } from "common/stompService";


const AttendanceCheck = () => {

    const [barcode, setBarcode] = useState("");
    let timer;
    const inputRef = useRef(null);
    const [attendanceType, setAttendanceType] = useState("door"); // door, purchase, online
    const [msg, setMsg] = useState("리더기에 회원바코드를 인식시켜주세요");
    const [usercode, setUsercode] = useState("");
    const [imgDisplay, setImgDisplay] = useState("block");

    //const onChange = (event) => { setAttendanceType(event.target.value); };


    const setAttendance = async (testVal) => {
      //console.log("usercodeType", typeof(usercode));
      //console.log("usercode: ", usercode);
      console.log("usercode: ", testVal);
      //let testInfo = { userCode: usercode, userAttendanceType: "door" }
      const testInfo = { userCode: testVal, userAttendanceType: "door" }
      await api.post(`${API.USER_ATTENDANCE_INSERT}`, testInfo).then((res) => {
        publishMessage("/api/attendance/customer/arrived", testVal);
        msgSet(testVal);
        setTimeout(msgReset, 3000);
      });
    }

    const msgSet = (usercode) => {
      setImgDisplay("none");
      setMsg(usercode + " 등록되었습니다.");
    }

    const msgReset = () => {
      setImgDisplay("block");
      setMsg("리더기에 회원바코드를 인식시켜주세요");
    }

    //const setVarcode = (e) =>{ setUsercode(e.target.value); }

    const handleKeyDown = (e) => {
      //console.log(e.key);
      setUsercode(usercode + e.key);
      //console.log("usercode", usercode);
      if(e.key === 'Enter') { 
        console.log("enterLogs");
        //setAttendance(); 
      }
    };

    //const [imageUrl, setImageUrl] = useState<string>();

    let imageUrl = "";
    const barcodeNumber = "3000000133";
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, barcodeNumber, { height: 100, displayValue: false });
    imageUrl = canvas.toDataURL('image/png');

    useEffect(() => {
      const mainElement = document.getElementById("main");
      if (mainElement) { mainElement.style.marginTop = "0"; }
      if (mainElement) { mainElement.style.marginLeft = "0"; }

      const headElement = document.getElementById("header");
      if (headElement) { headElement.remove();}
      const footElement = document.getElementById("footer");
      if (footElement) { footElement.remove();} 
      // const sideElement = document.getElementById("sidebar");
      // if (sideElement) { sideElement.remove();} 
           
      //window.addEventListener('keydown', handleKeyDown);
      //window.addEventListener('keyup', handleKeyDown);
      //window.addEventListener('keypress', handleKeyDown);

    const handleBarcodeScan = (event) => {
      clearTimeout(timer);
      if (event.key === "Enter") {
        setUsercode("" + barcode);
        console.log("스캔된 바코드:", barcode);
        setAttendance(barcode)
        setBarcode(""); // 초기화
      } else {
        setBarcode((prev) => prev + event.key);
        //console.log("스캔된 바코드:", barcode);
      }
      //setTimeout(() => setAttendance(), 300);
      //console.log("스캔된 바코드:", barcode);

      timer = setTimeout(() => setBarcode(""), 300);
    };


    const hiddenDiv = document.createElement("div");
    hiddenDiv.tabIndex = -1; // 포커스 가능하지만 UI 요소 아님
    document.body.appendChild(hiddenDiv);

    hiddenDiv.focus(); // 브라우저가 허용하는 포커스

      const input = document.getElementById("barcodePrecessInput");
      if (input) input.focus();

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 1000);

      // setTimeout(() => {
      //   const input = document.getElementById("barcodePrecessInput");
      //   if (input) {
      //     input.focus();
      //     input.select(); // 선택까지 해주면 확실하게 포커스됨
      //   }
      // }, 500);

      // document.addEventListener("keypress", () => {
      //   if (input) input.focus();
      // })

      //console.log("현재 포커스된 요소:", document.activeElement);
      window.addEventListener("keydown", handleBarcodeScan);
      window.addEventListener("keydown", () => {
        document.getElementById("barcodePrecessInput")?.focus();
      });

      window.addEventListener("load", () => {
        setTimeout(() => {
          window.focus();
          document.getElementById("barcodePrecessInput")?.focus();
        }, 500);
      });

      //console.log("이벤트 리스너 등록됨");
      return () => window.removeEventListener("keydown", handleBarcodeScan);

    });
    useLayoutEffect(() => {
      inputRef.current?.focus();
    }, []);

    return (
      <>
            <input 
            ref={inputRef}
            type="text" 
            name="usercode" 
            id="barcodePrecessInput"
            onChange={handleKeyDown} 
            className="form-control" 
            value={barcode}
            style={{display: "none"}}
            />

            {/*<div className="row mb-3" style={{display: "none"}}>
              <div className="col-sm-4">
                <select className="form-select" onChange={onChange} aria-label="Default select example" defaultValue={'door'}>
                    <option value="door">오프라인</option>
                    <option value="purchase">구매</option>
                    <option value="online">온라인</option>
                </select>
              </div>

              <div className="col-sm-2">
                <input type="text" name="usercode" onChange={setVarcode} className="form-control" defaultValue={usercode} />
              </div>

              <div className="col-sm-4">
                <button type="button" className="btn btn-primary" onClick={setAttendance}>check</button>
              </div>

            </div>*/}
            <div><img src={imageUrl} /></div>
            <CustomerButton />
              {msg}
              <img
              src="/images/sikaring_02.png"
              style={{ 
                width: "auth", 
                height: "auto", 
                maxWidth: "100%", 
                maxHeight: "100vh", 
                objectFit: "contain", 
                display: imgDisplay, 
                margin: "auto"
              }}
              />



      </>
    );

}

export default AttendanceCheck;